const IMAGE_EXTENSION_PATTERN = /\.(jpg|jpeg|png|gif|webp|avif|bmp|svg)(\?|$)/i;
const PDF_EXTENSION_PATTERN = /\.pdf(\?|$)/i;
const PDF_MIME_TYPES = new Set(['application/pdf']);

export function isImageFile(url?: string, mimeType?: string | null) {
  return (
    (mimeType?.startsWith('image/') ?? false) ||
    IMAGE_EXTENSION_PATTERN.test(url ?? '')
  );
}

export function isPdfFile(url?: string, mimeType?: string | null) {
  return (
    PDF_MIME_TYPES.has(mimeType ?? '') || PDF_EXTENSION_PATTERN.test(url ?? '')
  );
}
